var _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4175 6.7085C13.4175 7.23777 13.8464 7.66683 14.3754 7.66683C14.9044 7.66683 15.3333 7.23777 15.3333 6.7085L15.3333 5.75016C15.3333 3.63307 13.6178 1.91683 11.5016 1.91683H5.75497C3.6388 1.91683 1.9233 3.63307 1.9233 5.75016L1.9233 17.2502C1.9233 19.3673 3.6388 21.0835 5.75497 21.0835H11.5083C13.6245 21.0835 15.34 19.3673 15.34 17.2502V16.2918C15.34 15.7626 14.9111 15.3335 14.382 15.3335C13.853 15.3335 13.4241 15.7626 13.4241 16.2918V17.2502C13.4241 18.3087 12.5664 19.1668 11.5083 19.1668H5.75497C4.69688 19.1668 3.83914 18.3087 3.83914 17.2502L3.83914 5.75016C3.83914 4.69162 4.69688 3.8335 5.75497 3.8335H11.5016C12.5597 3.8335 13.4175 4.69162 13.4175 5.75016V6.7085Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.1666,
    y: 10.5415,
    width: 1.91667,
    height: 11.5,
    rx: 0.958334,
    transform: "rotate(90 19.1666 10.5415)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5723 9.30281C16.1981 8.92855 16.1981 8.32177 16.5723 7.94752C16.9466 7.57327 17.5534 7.57327 17.9276 7.94752L20.8026 10.8225C21.1769 11.1968 21.1769 11.8036 20.8026 12.1778L17.9276 15.0528C17.5534 15.4271 16.9466 15.4271 16.5723 15.0528C16.1981 14.6786 16.1981 14.0718 16.5723 13.6975L18.7697 11.5002L16.5723 9.30281Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.55b9039fdeeb0b5d0e656c92cec88f56.svg";
export { ForwardRef as ReactComponent };